import { colors } from '@configs/styles/config'
import { SVGProps } from 'react'
import * as React from 'react'

export const DeepInsightsBenefitIcon: React.FC<SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width="58"
    height="58"
    viewBox="0 0 58 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3792_25984)">
      <path
        d="M29 0C23.2644 0 17.6575 1.70082 12.8885 4.88738C8.11945 8.07394 4.40245 12.6031 2.20751 17.9022C0.0125653 23.2012 -0.561732 29.0322 0.55724 34.6576C1.67621 40.2831 4.43819 45.4504 8.49392 49.5061C12.5496 53.5618 17.7169 56.3238 23.3424 57.4428C28.9678 58.5618 34.7988 57.9875 40.0978 55.7925C45.3969 53.5976 49.9261 49.8806 53.1126 45.1115C56.2992 40.3425 58 34.7357 58 29C57.9917 21.3113 54.9337 13.9398 49.4969 8.50309C44.0602 3.06634 36.6887 0.00831595 29 0ZM52.1348 22.04L30.6071 26.2257C30.2683 25.7027 29.9709 25.1541 29.7178 24.5848L21.6461 5.97642C24.7018 4.99699 27.9222 4.63674 31.1188 4.91674C34.3154 5.19673 37.4241 6.11135 40.263 7.60709C43.1019 9.10284 45.6141 11.1497 47.6525 13.6279C49.6909 16.1061 51.2147 18.9659 52.1348 22.04ZM29 53.1667C23.6522 53.1686 18.455 51.3958 14.2231 48.1262C9.99126 44.8566 6.96412 40.275 5.61629 35.0999C4.26846 29.9247 4.67616 24.4486 6.77547 19.5301C8.87478 14.6115 12.547 10.5288 17.2163 7.92183L25.2832 26.5084C26.431 29.1503 28.2334 31.4559 30.5201 33.2074L46.5982 45.5131C44.346 47.9268 41.6217 49.8517 38.5943 51.1683C35.567 52.485 32.3013 53.1651 29 53.1667ZM49.5417 41.6754L34.7396 30.3461L53.0603 26.7863C53.1256 27.5113 53.1715 28.2533 53.1715 29C53.1694 33.4813 51.912 37.8723 49.5417 41.6754Z"
        fill={props.color ? props.color : colors.uguPurple}
      />
    </g>
    <defs>
      <clipPath id="clip0_3792_25984">
        <rect width="58" height="58" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
